import * as actions from 'actions';

export default (state = false, action) => {
  switch (action.type) {
    case actions.HIDE_HEADER:
      return true;
    case actions.SHOW_HEADER:
      return false;

    default:
      return action.meta ? false : state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/headerHidden.js